module.exports = __webpack_public_path__ + "static/media/spvie.81d50d2d.jpg";